/* ============================================
   Custom Scripts - Figma Design Implementation
   ============================================ */

(function () {
  'use strict';

  /* ===========================================
     SELECTOR CONFIG — Update here when the
     Shopify Subscriptions app changes its DOM.
     =========================================== */
  var SEL = {
    // --- Stable (data-attributes, unlikely to change) ---
    radioOtp:       'input[data-radio-type="one_time_purchase"]',
    radioAbo:       'input[data-radio-type="selling_plan"]',
    variantSection: 'section[data-variant-id]',

    // --- App class names (may change on app update) ---
    container:      '.shopify_subscriptions_app_container',
    // Row wrappers — used as fallback when bottom-up traversal isn't enough
    rowGroup:       '.subscription_group, .shopify_subscriptions_app_block_label',
    aboWrapper:     '.title_and_price_wrapper, .shopify_subscriptions_purchase_option_wrapper',
    aboLabel:       '.group_name, label',
    planList:       '.group_list, .shopify_subscriptions_app_block_label_children',
    priceEl:        '.in_widget_price, .shopify_subscriptions_in_widget_price',
    fieldset:       '.shopify_subscriptions_fieldset',

    // --- Theme selectors (our own, stable) ---
    buyButton:      'product-info .product-form__submit',
    priceBadge:     'product-info .price__badge-sale'
  };

  /* ===========================================
     HEALTH CHECK — Warns in console if expected
     elements are missing after widget loads.
     =========================================== */
  function healthCheck(container) {
    var checks = [
      { name: 'Container',         el: container },
      { name: 'Variant sections',  el: container.querySelector(SEL.variantSection) },
      { name: 'OTP radio',         el: container.querySelector(SEL.radioOtp) },
      { name: 'Abo radio',         el: container.querySelector(SEL.radioAbo) }
    ];

    var ok = true;
    checks.forEach(function (c) {
      if (!c.el) {
        console.warn('[Abo-Widget] ⚠️ "' + c.name + '" nicht gefunden — Shopify Subscriptions App Update?');
        ok = false;
      }
    });

    // Check app-specific selectors (the fragile ones)
    var section = container.querySelector(SEL.variantSection);
    if (section) {
      var otpRadio = section.querySelector(SEL.radioOtp);
      var aboRadio = section.querySelector(SEL.radioAbo);

      if (otpRadio) {
        var otpRow = findRowFromRadio(otpRadio);
        if (!otpRow) {
          console.warn('[Abo-Widget] ⚠️ OTP radio gefunden, aber kein Parent-Row via "' + SEL.rowGroup + '" — Selektor in SEL.rowGroup prüfen');
          ok = false;
        }
      }
      if (aboRadio) {
        var aboRow = findRowFromRadio(aboRadio);
        if (!aboRow) {
          console.warn('[Abo-Widget] ⚠️ Abo radio gefunden, aber kein Parent-Row via "' + SEL.rowGroup + '" — Selektor in SEL.rowGroup prüfen');
          ok = false;
        }
      }
    }

    if (ok) {
      console.log('[Abo-Widget] ✓ Health-Check bestanden — alle Selektoren matchen');
    }
    return ok;
  }

  /* ===========================================
     BOTTOM-UP ROW FINDER — Traverses from the
     stable radio inputs upward to find row
     containers, instead of top-down class search.
     =========================================== */
  function findRowFromRadio(radio) {
    // Try each selector in SEL.rowGroup (comma-separated)
    var selectors = SEL.rowGroup.split(',').map(function (s) { return s.trim(); });
    for (var i = 0; i < selectors.length; i++) {
      var row = radio.closest(selectors[i]);
      if (row) return row;
    }
    return null;
  }

  // Global purchase preference — persists across variant switches
  var purchasePreference = { mode: null, planIndex: 0 }; // mode: 'abo' | 'otp' | null

  function createTruckIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');

    var rect = document.createElementNS(ns, 'rect');
    rect.setAttribute('x', '1');
    rect.setAttribute('y', '3');
    rect.setAttribute('width', '15');
    rect.setAttribute('height', '13');
    svg.appendChild(rect);

    var polygon = document.createElementNS(ns, 'polygon');
    polygon.setAttribute('points', '16 8 20 8 23 11 23 16 16 16 16 8');
    svg.appendChild(polygon);

    var c1 = document.createElementNS(ns, 'circle');
    c1.setAttribute('cx', '5.5');
    c1.setAttribute('cy', '18.5');
    c1.setAttribute('r', '2.5');
    svg.appendChild(c1);

    var c2 = document.createElementNS(ns, 'circle');
    c2.setAttribute('cx', '18.5');
    c2.setAttribute('cy', '18.5');
    c2.setAttribute('r', '2.5');
    svg.appendChild(c2);

    return svg;
  }

  /* --- Find OTP row and Abo row via bottom-up traversal from radios --- */
  function findRows(section) {
    var otpRadio = section.querySelector(SEL.radioOtp);
    var aboRadio = section.querySelector(SEL.radioAbo);

    return {
      otpRow: otpRadio ? findRowFromRadio(otpRadio) : null,
      aboRow: aboRadio ? findRowFromRadio(aboRadio) : null
    };
  }

  /* Enhance a single variant section */
  function enhanceSection(section) {
    if (section.dataset.enhanced) return;

    var rows = findRows(section);
    if (!rows.otpRow || !rows.aboRow) return;

    // --- 1. OTP row: Translate "One-time purchase" -> "Einzellieferung" ---
    var otpLabel = rows.otpRow.querySelector('label');
    if (otpLabel) {
      replaceTextInNode(otpLabel, /one[- ]time purchase/i, 'Einzellieferung');
    }

    // --- 2. Abo row: Add custom radio + translate label -> "Abo" + add -10% orange badge ---
    var aboWrapper = queryMulti(rows.aboRow, SEL.aboWrapper);
    if (aboWrapper) {
      var aboLabel = queryMulti(aboWrapper, SEL.aboLabel);
      if (aboLabel && !aboWrapper.querySelector('.abo-discount-badge')) {
        // Insert a visual radio indicator before the label/group_name
        if (!aboWrapper.querySelector('.custom-abo-radio')) {
          var fakeRadio = document.createElement('span');
          fakeRadio.className = 'custom-abo-radio';
          aboWrapper.insertBefore(fakeRadio, aboLabel);
        }

        replaceTextInNode(aboLabel, /subscribe\s*(?:&|and)\s*save/i, 'Abo');
        // Wrap "Abo" text node in <strong>
        for (var j = 0; j < aboLabel.childNodes.length; j++) {
          var n = aboLabel.childNodes[j];
          if (n.nodeType === Node.TEXT_NODE && n.textContent.trim() === 'Abo') {
            var strong = document.createElement('strong');
            strong.textContent = 'Abo';
            aboLabel.replaceChild(strong, n);
            break;
          }
        }

        var badge = document.createElement('span');
        badge.className = 'abo-discount-badge';
        badge.textContent = '-10%';
        aboWrapper.appendChild(badge);

        // Add Abo price to header (right-aligned)
        var aboPriceEl = queryMulti(rows.aboRow, SEL.priceEl);
        if (aboPriceEl) {
          var headerPrice = document.createElement('span');
          headerPrice.className = 'abo-header-price';
          headerPrice.textContent = aboPriceEl.textContent.trim();
          aboWrapper.appendChild(headerPrice);
        }

        // Style the abo header as flex row
        aboWrapper.classList.add('custom-abo-header');
      }
    }

    // --- 3. Translate selling plan labels ---
    section.querySelectorAll(SEL.radioAbo).forEach(function (radio) {
      var label = radio.closest('label') || radio.parentElement;
      if (label) translateFrequencyText(label);
    });

    // --- 4. Inside Abo card: hide original plan radios, add discount text + delivery row with dropdown ---
    var planList = queryMulti(rows.aboRow, SEL.planList);
    if (planList) {
      planList.style.display = 'none';
    }

    if (!rows.aboRow.querySelector('.custom-abo-details')) {
      var details = document.createElement('div');
      details.className = 'custom-abo-details';

      var discountText = document.createElement('div');
      discountText.className = 'custom-abo-discount-text';
      discountText.textContent = 'Erhalte 10% Rabatt auf jede Lieferung';
      details.appendChild(discountText);

      var row = document.createElement('div');
      row.className = 'custom-delivery-row';

      row.appendChild(createTruckIcon());

      var textSpan = document.createElement('span');
      textSpan.className = 'custom-delivery-text';
      textSpan.textContent = '2-3 Tage geliefert';
      row.appendChild(textSpan);

      var planRadiosForSelect = rows.aboRow.querySelectorAll(SEL.radioAbo);
      if (planRadiosForSelect.length > 1) {
        var select = document.createElement('select');
        select.className = 'custom-delivery-select';
        planRadiosForSelect.forEach(function (radio, idx) {
          var option = document.createElement('option');
          var labelEl = radio.closest('label') || radio.parentElement;
          var labelText = labelEl ? labelEl.textContent.trim() : 'Plan ' + (idx + 1);
          option.textContent = simplifyFrequency(labelText);
          option.value = idx;
          if (radio.checked) option.selected = true;
          select.appendChild(option);
        });
        select.addEventListener('change', function () {
          var selectedRadio = planRadiosForSelect[parseInt(this.value)];
          if (selectedRadio) {
            selectedRadio.checked = true;
            selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        row.appendChild(select);
      } else {
        var freqSpan = document.createElement('span');
        freqSpan.className = 'custom-delivery-frequency';
        var singleLabel = planRadiosForSelect[0] ? (planRadiosForSelect[0].closest('label') || planRadiosForSelect[0].parentElement) : null;
        freqSpan.textContent = singleLabel ? simplifyFrequency(singleLabel.textContent.trim()) : 'Alle 7 Tage';
        row.appendChild(freqSpan);
      }

      details.appendChild(row);
      rows.aboRow.appendChild(details);
    }

    // --- 5. Make entire Abo card clickable (plan radios are hidden) ---
    // Remember last selected plan so switching OTP→Abo restores the choice
    var lastSelectedPlanIndex = 0;
    // Track plan changes
    var allPlans = rows.aboRow.querySelectorAll(SEL.radioAbo);
    allPlans.forEach(function (radio, idx) {
      radio.addEventListener('change', function () {
        if (radio.checked) lastSelectedPlanIndex = idx;
      });
      if (radio.checked) lastSelectedPlanIndex = idx;
    });

    if (!rows.aboRow.dataset.enhancedClick) {
      rows.aboRow.dataset.enhancedClick = '1';
      rows.aboRow.style.cursor = 'pointer';
      rows.aboRow.addEventListener('click', function (e) {
        if (e.target.closest('.custom-delivery-select')) return; // don't interfere with dropdown
        // Keep current selection, or restore last selection, or fall back to first
        var currentPlan = rows.aboRow.querySelector(SEL.radioAbo + ':checked');
        var targetPlan = currentPlan || allPlans[lastSelectedPlanIndex] || allPlans[0];
        if (targetPlan) {
          targetPlan.checked = true;
          targetPlan.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // --- 6. Make entire OTP card clickable ---
    if (!rows.otpRow.dataset.enhancedClick) {
      rows.otpRow.dataset.enhancedClick = '1';
      rows.otpRow.style.cursor = 'pointer';
      rows.otpRow.addEventListener('click', function () {
        var otpRadio = rows.otpRow.querySelector(SEL.radioOtp);
        if (otpRadio) {
          otpRadio.checked = true;
          otpRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // --- 7. Radio change handlers + track purchase preference ---
    section.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      if (radio.dataset.enhancedHandler) return;
      radio.dataset.enhancedHandler = '1';
      radio.addEventListener('change', function () {
        // Track preference globally
        if (radio.dataset.radioType === 'one_time_purchase' && radio.checked) {
          purchasePreference.mode = 'otp';
          setAllSellingPlanInputs('');
        } else if (radio.dataset.radioType === 'selling_plan' && radio.checked) {
          purchasePreference.mode = 'abo';
          var plans = rows.aboRow.querySelectorAll(SEL.radioAbo);
          plans.forEach(function (p, idx) { if (p.checked) purchasePreference.planIndex = idx; });
          setAllSellingPlanInputs(radio.dataset.sellingPlanId);
        }
        updateDeliveryFrequency();
        updateButtonText();
        updateDeliveryRowVisibility();
        updatePriceBadge();
        updateActiveCardState();
      });
    });

    // Initial state updates
    updateDeliveryRowVisibility();
    updatePriceBadge();
    updateActiveCardState();

    section.dataset.enhanced = '1';
  }

  /* ===========================================
     RECHARGE-PLAN FILTER — Remove plan-radios
     that aren't in the Shopify-Subscriptions
     whitelist. Plan-ID is in data-selling-plan-id
     (NOT in radio.value which is "on" for all).
     Whitelist source priority:
       1. window.__shopifyValidPlanIds (set by main-product.liquid per-product)
       2. SHOPIFY_PLAN_IDS_FALLBACK (hardcoded, current Selling Plan IDs)
     Idempotent: safe to call repeatedly.
     =========================================== */
  var SHOPIFY_PLAN_IDS_FALLBACK = ['8634630411', '8634663179']; // Abo & Sparen plans

  /* Force-sync selling_plan inputs across ALL forms on the page.
     app-block.js only updates inputs inside its shopifySection — but Dawn
     has multiple cart-add forms (main product form + sticky/quick-add).
     If we don't sync them all, the form actually submitted may have an
     empty selling_plan, causing Abo selections to be lost on variant switch. */
  function setAllSellingPlanInputs(planId) {
    var val = planId || '';
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      input.value = val;
    });
  }

  function removeRechargePlans(container) {
    var dynamicIds = window.__shopifyValidPlanIds;
    var validIds = (Array.isArray(dynamicIds) && dynamicIds.length > 0)
      ? dynamicIds
      : SHOPIFY_PLAN_IDS_FALLBACK;
    var validIdSet = validIds.map(String);

    var aboRadios = container.querySelectorAll(SEL.radioAbo);
    var hidden = 0;
    aboRadios.forEach(function (radio) {
      var planId = radio.dataset.sellingPlanId || radio.value;
      var keep = validIdSet.indexOf(String(planId)) !== -1;
      if (keep) return;
      // Plan is NOT whitelisted → hide its .subscription_group container.
      // We hide (not remove) so app-block.js can still iterate plan radios
      // internally without crashing on undefined.
      var row = radio.closest('.subscription_group')
              || radio.closest('.shopify_subscriptions_app_block_label')
              || radio.closest('.shopify_subscriptions_purchase_option_wrapper')
              || radio.closest('label');
      if (row && row !== container && !row.dataset.recharFiltered) {
        row.dataset.recharFiltered = '1';
        row.style.display = 'none';
        row.setAttribute('aria-hidden', 'true');
        radio.disabled = true;
        hidden++;
      }
    });
  }

  function enhanceSubscriptionWidget() {
    var container = document.querySelector(SEL.container);
    if (!container) return false;

    // Filter out Recharge plan-radios before enhancement reads the DOM
    removeRechargePlans(container);

    var sections = container.querySelectorAll(SEL.variantSection);
    if (sections.length === 0) return false;

    // Run health check on first enhancement
    if (!container.dataset.healthChecked) {
      container.dataset.healthChecked = '1';
      healthCheck(container);
    }

    var anyNew = false;
    sections.forEach(function (section) {
      if (!section.dataset.enhanced) {
        enhanceSection(section);
        anyNew = true;
      }
    });

    // Only run global updates when new sections were enhanced (not on every mutation)
    if (anyNew) {
      updateDeliveryFrequency();
      updateButtonText();
      updateDeliveryRowVisibility();
      updatePriceBadge();
      updateActiveCardState();
    }

    // Watch for variant switches (section visibility changes) and restore preference
    if (!container.dataset.variantObserver) {
      container.dataset.variantObserver = '1';
      var lastActiveVariant = null;
      var variantObserver = new MutationObserver(function () {
        var active = findActiveSection(container);
        var activeId = active ? active.dataset.variantId : null;
        if (activeId && activeId !== lastActiveVariant) {
          lastActiveVariant = activeId;
          applyPreferenceToActiveSection();
        }
      });
      variantObserver.observe(container, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
    }

    // Watch the <product-info> element for AJAX re-renders (variant switch in Dawn).
    // After Dawn replaces the price markup, the .price__badge-sale loses its
    // .show-abo-badge class — we re-apply it here. Debounced to avoid thrashing.
    var productInfo = container.closest('product-info');
    if (productInfo && !productInfo.dataset.priceBadgeWatched) {
      productInfo.dataset.priceBadgeWatched = '1';
      var badgeDebounce = null;
      var productInfoObserver = new MutationObserver(function () {
        clearTimeout(badgeDebounce);
        badgeDebounce = setTimeout(function () {
          updatePriceBadge();
        }, 30);
      });
      productInfoObserver.observe(productInfo, { childList: true, subtree: true });
    }

    return true;
  }

  // --- Helpers ---

  /* Query with comma-separated fallback selectors (tries each until one matches) */
  function queryMulti(parent, selectorString) {
    var selectors = selectorString.split(',').map(function (s) { return s.trim(); });
    for (var i = 0; i < selectors.length; i++) {
      var el = parent.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function replaceTextInNode(el, pattern, replacement) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && pattern.test(node.textContent)) {
        node.textContent = node.textContent.replace(pattern, replacement);
      }
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'INPUT') {
        replaceTextInNode(node, pattern, replacement);
      }
    }
  }

  /* Reduce a full selling-plan label like "Jede Woche liefern, 10 % Rabatt"
     down to just the frequency in days: "Alle 7 Tage" */
  function simplifyFrequency(text) {
    // German labels from Shopify Subscriptions app
    var m;
    if ((m = text.match(/(\d+)\s*Wochen?/i))) return 'Alle ' + (parseInt(m[1]) * 7) + ' Tage';
    if (/Jede\s+Woche/i.test(text)) return 'Alle 7 Tage';
    if ((m = text.match(/(\d+)\s*Tage?/i))) return 'Alle ' + m[1] + ' Tage';
    if (/Jeden\s+Tag/i.test(text)) return 'Jeden Tag';
    if ((m = text.match(/(\d+)\s*Monate?/i))) return 'Alle ' + m[1] + ' Monate';
    if (/Jeden\s+Monat/i.test(text)) return 'Jeden Monat';
    // English fallbacks
    if ((m = text.match(/every\s+(\d+)\s+weeks?/i))) return 'Alle ' + (parseInt(m[1]) * 7) + ' Tage';
    if (/every\s+week/i.test(text)) return 'Alle 7 Tage';
    if ((m = text.match(/every\s+(\d+)\s+days?/i))) return 'Alle ' + m[1] + ' Tage';
    if (/every\s+day/i.test(text)) return 'Jeden Tag';
    return text;
  }

  function translateFrequencyText(label) {
    for (var i = 0; i < label.childNodes.length; i++) {
      var node = label.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent
          .replace(/every\s+(\d+)\s+weeks?/i, function (m, n) { return 'Alle ' + (parseInt(n) * 7) + ' Tage'; })
          .replace(/every\s+week/i, 'Alle 7 Tage')
          .replace(/every\s+(\d+)\s+days?/i, 'Alle $1 Tage')
          .replace(/every\s+day/i, 'Jeden Tag')
          .replace(/every\s+(\d+)\s+months?/i, 'Alle $1 Monate')
          .replace(/every\s+month/i, 'Jeden Monat')
          .replace(/delivery every/i, 'Lieferung alle');
      }
    }
  }

  /* Find the currently active/visible variant section */
  function findActiveSection(container) {
    var sections = container.querySelectorAll(SEL.variantSection);
    for (var i = 0; i < sections.length; i++) {
      // Shopify hides non-active variant sections
      if (sections[i].offsetParent !== null) return sections[i];
    }
    return sections[0] || null;
  }

  /* Auto-select first selling plan when Abo is selected (not OTP) */
  function autoSelectFirstPlan(section, rows) {
    var otpChecked = rows.otpRow.querySelector(SEL.radioOtp + ':checked');
    if (otpChecked) return;

    var anyPlanChecked = section.querySelector(SEL.radioAbo + ':checked');
    if (anyPlanChecked) return;

    var firstPlan = section.querySelector(SEL.radioAbo);
    if (firstPlan) {
      firstPlan.checked = true;
      firstPlan.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var originalButtonText = '';

  function updateButtonText() {
    var container = document.querySelector(SEL.container);
    var btn = document.querySelector(SEL.buyButton);
    if (!btn || !container) return;

    // Target the <span> inside the button, not the button itself
    var btnSpan = btn.querySelector('span');
    if (!btnSpan) return;

    if (!originalButtonText) {
      originalButtonText = btnSpan.textContent.trim();
    }

    var section = findActiveSection(container);
    var isAbo = section && section.querySelector(SEL.radioAbo + ':checked');
    btnSpan.textContent = isAbo ? 'Abo starten & 10% sparen' : originalButtonText;
  }

  function updateDeliveryFrequency() {
    var container = document.querySelector(SEL.container);
    if (!container) return;
    var section = findActiveSection(container);
    if (!section) return;

    var freqEl = section.querySelector('.custom-delivery-frequency');
    if (freqEl) {
      var checked = section.querySelector(SEL.radioAbo + ':checked');
      if (checked) {
        var label = checked.closest('label') || checked.parentElement;
        if (label) freqEl.textContent = simplifyFrequency(label.textContent.trim());
      }
    }

    var select = section.querySelector('.custom-delivery-select');
    if (select) {
      var rows = findRows(section);
      if (rows.aboRow) {
        var planRadios = rows.aboRow.querySelectorAll(SEL.radioAbo);
        planRadios.forEach(function (radio, idx) {
          if (radio.checked) select.value = idx;
        });
      }
    }
  }

  /* Toggle .subscription-card-selected class + fake Abo radio state */
  function updateActiveCardState() {
    var container = document.querySelector(SEL.container);
    if (!container) return;
    var section = findActiveSection(container);
    if (!section) return;

    var rows = findRows(section);
    if (!rows.otpRow || !rows.aboRow) return;

    var isAbo = !!section.querySelector(SEL.radioAbo + ':checked');

    rows.otpRow.classList.toggle('subscription-card-selected', !isAbo);
    rows.aboRow.classList.toggle('subscription-card-selected', isAbo);

    // Update fake Abo radio visual
    var fakeRadio = rows.aboRow.querySelector('.custom-abo-radio');
    if (fakeRadio) {
      fakeRadio.classList.toggle('checked', isAbo);
    }

    // Update Abo header price from current plan
    var headerPrice = rows.aboRow.querySelector('.abo-header-price');
    var aboPriceEl = queryMulti(rows.aboRow, SEL.priceEl);
    if (headerPrice && aboPriceEl) {
      headerPrice.textContent = aboPriceEl.textContent.trim();
    }
  }

  function updateDeliveryRowVisibility() {
    // Abo details are always visible (not hidden when OTP selected)
  }

  /* Show/hide price badge based on subscription selection.
     When Abo is selected: show badge with abo discount (e.g. -10%).
     When Einzellieferung (or no widget): hide badge completely.
     The compare-at badge from Liquid is repurposed for abo discount only. */
  function updatePriceBadge() {
    var container = document.querySelector(SEL.container);
    var badge = document.querySelector(SEL.priceBadge);
    if (!badge) return;

    if (!container) {
      badge.classList.remove('show-abo-badge');
      return;
    }

    var section = findActiveSection(container);
    if (!section) {
      badge.classList.remove('show-abo-badge');
      return;
    }

    var isAbo = section.querySelector(SEL.radioAbo + ':checked');
    if (isAbo) {
      badge.classList.add('show-abo-badge');
      var rows = findRows(section);
      var aboPrice = null;
      var otpPrice = null;
      if (rows.aboRow) {
        var aboPriceEl = queryMulti(rows.aboRow, SEL.priceEl);
        if (aboPriceEl) aboPrice = parsePrice(aboPriceEl.textContent);
      }
      if (rows.otpRow) {
        var otpPriceEl = queryMulti(rows.otpRow, SEL.priceEl);
        if (otpPriceEl) otpPrice = parsePrice(otpPriceEl.textContent);
      }
      if (otpPrice > 0 && aboPrice > 0 && aboPrice < otpPrice) {
        var pct = Math.round(((otpPrice - aboPrice) / otpPrice) * 100);
        badge.textContent = '-' + pct + '%';
      } else {
        badge.textContent = '-10%';
      }
    } else {
      badge.classList.remove('show-abo-badge');
    }
  }

  function parsePrice(text) {
    // Extract number from price string like "27,00€" or "€27.00"
    var cleaned = text.replace(/[^\d,.]/g, '').replace(',', '.');
    return parseFloat(cleaned) || 0;
  }

  /* Apply saved purchase preference to the currently visible variant section */
  function applyPreferenceToActiveSection() {
    if (!purchasePreference.mode) return;
    var container = document.querySelector(SEL.container);
    if (!container) return;
    var section = findActiveSection(container);
    if (!section) return;

    var rows = findRows(section);
    if (!rows.otpRow || !rows.aboRow) return;

    if (purchasePreference.mode === 'abo') {
      var plans = rows.aboRow.querySelectorAll(SEL.radioAbo);
      var target = plans[purchasePreference.planIndex] || plans[0];
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Force-sync selling_plan inputs across all forms (app-block.js misses some after variant switch)
      setAllSellingPlanInputs(target?.dataset.sellingPlanId);
      // Sync dropdown
      var select = section.querySelector('.custom-delivery-select');
      if (select) select.value = purchasePreference.planIndex;
    } else if (purchasePreference.mode === 'otp') {
      var otpRadio = rows.otpRow.querySelector(SEL.radioOtp);
      if (otpRadio && !otpRadio.checked) {
        otpRadio.checked = true;
        otpRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setAllSellingPlanInputs('');
    }
  }

  /* Belt-and-suspenders: directly before any cart-add form submits, force-set
     the selling_plan input value based on the currently-checked radio in the
     active variant section. This protects against other scripts (Recharge,
     sticky/quick-add re-renders) clearing the input after our sync. */
  function installSubmitGuard() {
    if (window.__custom_atc_guard) return;
    window.__custom_atc_guard = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

      var sp = form.querySelector('input[name="selling_plan"]');
      if (!sp) return;

      var container = document.querySelector(SEL.container);
      if (!container) return;
      var section = findActiveSection(container);
      if (!section) return;

      var checked = section.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      if (checked.dataset.radioType === 'selling_plan') {
        sp.value = checked.dataset.sellingPlanId || '';
      } else if (checked.dataset.radioType === 'one_time_purchase') {
        sp.value = '';
      }
    }, true); // capture phase: run before any other submit handler
  }

  // --- Init: persistent observer for AJAX-driven re-renders (variant switch) ---

  function init() {
    enhanceSubscriptionWidget();
    installSubmitGuard();

    // Keep observing — Dawn replaces <product-info> on variant change.
    // enhanceSubscriptionWidget is idempotent (data-enhanced, data-variantObserver markers).
    // Debounced to avoid thrashing on rapid mutations.
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        enhanceSubscriptionWidget();
        // Re-apply purchase preference (abo/otp) to whichever variant section is now active
        applyPreferenceToActiveSection();
      }, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
